import Navigation from '../components/landing/Navigation';
import Hero from '../components/landing/Hero';
import FeatureCarousel from '../components/landing/FeatureCarousel';
import ValueProps from '../components/landing/ValueProps';
import HowItWorks from '../components/landing/HowItWorks';
import FAQ from '../components/landing/FAQ';
import Footer from '../components/landing/Footer';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <FeatureCarousel />
      <ValueProps />
      <HowItWorks />
      <FAQ />
      <Footer />
    </div>
  );
}
